import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'dark' | 'light';
}
const JAG_LOGO_URL = 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/wZmCOMOYUn4CfsoCHQM0/media/699617b9905d472601bbd7ed.svg';
export function Logo({
  className = '',
  variant = 'dark'
}: LogoProps) {
  const isFooter = variant === 'light';
  return <div className={`relative shrink-0 overflow-hidden ${isFooter ? 'h-[78px] w-[360px]' : 'h-[74px] w-[min(300px,calc(100vw-96px))] sm:h-[66px] sm:w-[340px]'} ${className}`} data-id="element-137" data-mp="msuqq7mm83ev">
      <img src={JAG_LOGO_URL} alt="JAG Medical Solutions" className={`absolute left-1/2 top-1/2 h-auto max-w-none -translate-x-1/2 -translate-y-1/2 sm:-translate-y-[47%] ${isFooter ? 'w-[360px]' : 'w-full sm:w-[340px]'}`} data-id="element-138" data-mp="rpl6suyf6z0a" />
    </div>;
}